export const cardItems = [{
  name: 'Kika',
  specie: 'Hispaniolan Amazon',
  age: '15 Years',
  image: '/Amazon.jpg'
},
{
  name: 'Bruno',
  specie: 'Hispaniolan Amazon',
  age: '2 Years',
  image: '/bruno.jpg'
},
{
  name: 'Coco',
  specie: 'African Parrot',
  age: '20 Years',
  image: '/african.jpg'
}, {
  name: 'Cuca',
  specie: 'Australia Parrot',
  age: '12 Years',
  image: '/1D3F1580.jpg'
}]